import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "address", "destroy"]

  add() {
    const template = this.templateTarget.content.cloneNode(true)
    const wrapper = template.querySelector(".practice-address")
    if (!wrapper) return

    const index = Date.now()
    wrapper.innerHTML = wrapper.innerHTML.replaceAll("NEW_ADDRESS", String(index))
    this.listTarget.appendChild(wrapper)
  }

  remove(event) {
    const address = event.currentTarget.closest(".practice-address")
    if (!address) return

    const destroy = address.querySelector("[data-practice-addresses-target='destroy']")
    const persisted = address.querySelector("input[name*='[id]']")
    if (destroy && persisted) {
      destroy.value = "1"
      address.hidden = true
      return
    }

    address.remove()
  }
}
